// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_b-0";
export var skeletonCard = "_b-1";